import { NgModule } from '@angular/core';
import { SsfExampleComponent } from './ssf-example.component';



@NgModule({
  declarations: [SsfExampleComponent],
  imports: [
  ],
  exports: [SsfExampleComponent]
})
export class SsfExampleModule { }
